import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.3498 6.66162C21.1319 6.44315 20.8359 6.32038 20.5273 6.32038C20.2187 6.32038 19.9228 6.44315 19.7048 6.66162L13.9998 12.3549L8.29484 6.64995C8.07687 6.43149 7.78095 6.30872 7.47234 6.30872C7.16374 6.30872 6.86781 6.43149 6.64984 6.64995C6.19484 7.10495 6.19484 7.83995 6.64984 8.29495L12.3548 13.9999L6.64984 19.7049C6.19484 20.1599 6.19484 20.8949 6.64984 21.3499C7.10484 21.8049 7.83984 21.8049 8.29484 21.3499L13.9998 15.6449L19.7048 21.3499C20.1598 21.8049 20.8948 21.8049 21.3498 21.3499C21.8048 20.8949 21.8048 20.1599 21.3498 19.7049L15.6448 13.9999L21.3498 8.29495C21.7932 7.85162 21.7932 7.10495 21.3498 6.66162Z",
		fill: "current"
	})
});
export default SvgCross;
